import { useCartContext } from 'features/cart/hooks/use-cart-context';
import { useIntl } from 'react-intl';
import { View } from 'react-native';

import { CartEntry } from '../cart-entry';
import { CartSectionHeader } from '../cart-section-header';

export const YourCartSection = () => {
  const { formatMessage } = useIntl();
  const { cartEntries } = useCartContext();
  const reversedCartEntries = cartEntries.slice().reverse();

  return (
    <View style={{ gap: 16, marginTop: 10 }}>
      <CartSectionHeader
        title={formatMessage({ id: 'yourCart' })}
        testID="cart-section-heading-label"
      />

      {/* render cart entries in inverse order */}
      {reversedCartEntries.map(entry => (
        <CartEntry key={entry.cartId} cartEntry={entry} />
      ))}
    </View>
  );
};
